<div class="container-md p-md-0 mb-5">
  <ts-asset-selection
    header="{{ 'my_eligible_lines' | translate }}"
    no_asset_text="{{ 'no_eligible_lines' | translate }}"
    [asset_fields]="['plan', 'sim_number', 'add_on_features', 'contract_end_date']"
    [existing_asset]="shopping_cart && shopping_cart.existing_asset"
    (asset_selection_emit)="selectAsset($event)"
  />
</div>
